<template>
  <div>
      <section>
        <div class="container">
          <div class="col-12 col-lg-10 mx-auto px-0 d-flex">
            <!-- CONTENT -->
            <div class="col-12 col-md-8">
              <!-- COVER -->
              <div class="cover mb-4">
                <div class="image-header rounded-regular" :style="coverImage">
                  <label for="cover" class="btn btn-white mb-3 mb-md-0">Adicionar imagem</label>
                  <input
                    type="file"
                    name="cover"
                    id="cover"
                    style="display: none;"
                    @change="changeCover"
                    accept="image/*"
                  />
                  <Button
                    class="btn btn-white mt-3 mt-md-0 ml-md-1 ml-lg-3"
                    @click="$bvModal.show('select-cover')"
                  >
                    Selecionar modelo
                  </Button>
                </div>
                <p class="font-size-xSmall mt-2 text-color2 mb-0 text-center text-lg-left">Tamanho ideal: 1110px x 350px</p>
              </div>
              <CoverSelectModal
                @cover-selected="setDefaultCover"
              />
              <CropperModal
                :src="cropSrc"
                @cropped="setCover"
              />
              <!-- TITLE -->
              <div class="form-group mb-4">
                <input
                  type="text"
                  class="form-control font-weight-bold font-size-medium bordered-bottom text-left w-100"
                  name="title"
                  placeholder="Título"
                  v-model.trim="post.title"
                  @blur="setSlug"
                />
              </div> <!-- END TITLE -->
              <!-- POST CONTENT -->
              <div class="form-group mb-4">
                <Editor
                  @content-updated="updateContent"
                  v-model="post.content"
                />
              </div> <!-- END POST CONTENT -->
              <!-- <div>
                {{ post.content }}
              </div> -->
            </div> <!-- END CONTENT -->
            <!-- CONFIGS -->
            <div
              class="col-12 col-md-4 sidebar"
              :class="{
                open: isSidebarOpen
              }"
            >
              <!-- GERAL -->
              <div
                class="mb-4 text-center text-md-left"
                v-if="currentPost && currentPost.status !== 'published'"
              >
                <Button
                  class="btn btn-sm btn-outline-color2"
                  @click="discardDraft"
                  :loading="discardingDraft"
                >
                  Descartar rascunho
                </Button>
              </div>
              <div class="mb-5">
                <h2 class="font-weight-bold font-size-regular text-center text-md-left mb-3">Informações básicas</h2>
                <div class="form-group mb-4">
                  <textarea
                    class="form-control no-border font-size-small w-100 text-left px-0 py-0"
                    name="description"
                    :placeholder="`Escreva aqui um resumo sobre seu ${isChapter ? 'capítulo' : 'texto' }`"
                    v-model.trim="post.description"
                  ></textarea>
                  <p class="font-size-small text-right">
                    <span
                      class="d-inline-block"
                      :class="{
                        'text-color4': post.description.length > 700
                      }"
                    >
                      {{ post.description.length }}
                    </span>/700
                  </p>
                </div>
                <div class="form-group mb-4">
                  <span class="d-block font-size-small">{{ basePermalink }}/</span>
                  <input
                    type="text"
                    class="form-control bordered-bottom font-size-small py-0 px-0 text-left w-100 font-weight-bold text-color2"
                    name="slug"
                    placeholder="URL"
                    v-model.trim="post.slug"
                  />
                </div>
                <div
                  class="mb-4 text-center text-md-left"
                  v-if="currentPost"
                >
                  <Button
                    class="btn btn-sm btn-outline-color2"
                    @click="seePreview"
                    :disabled="isDisabled"
                    :loading="isDisabled"
                  >
                    Ver prévia
                  </Button>
                </div>
              </div> <!-- END GERAL -->
              <!-- VISIBILITY -->
              <div class="mb-5">
                <h2 class="font-weight-bold font-size-regular text-center text-md-left mb-3">Publicação e visibilidade</h2>
                <!-- VISIBILITY -->
                <div class="form-group">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-small">Visibilidade</span>
                    <div>
                      <DropdownSelect
                        v-model.trim="post.visibility"
                        :options="visibilityOptions"
                        size="xSmall"
                      />
                    </div>
                  </div>
                  <p class="font-size-xSmall mt-2 text-color2 mb-0 text-right text-lg-left">Dica: {{ visibilityTipText }}</p>
                </div> <!-- END VISIBILITY -->
                <!-- SCHEDULE -->
                <div class="form-group">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="font-size-small">Publicar</span>
                    <div>
                      <DropdownSelect
                        v-model.trim="post.publish_method"
                        :options="publishMethods"
                        size="xSmall"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-3 pl-3"
                    v-if="post.publish_method === 'schedule'"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="font-size-xSmall">Escolha uma data</span>
                      <DateTimeInput
                        v-model.trim="post.publish_at"
                        :value="'2021-01-01 15:00:00'"
                        theme="basic"
                      />
                    </div>
                    <p class="font-size-xSmall mt-2 text-color2 mb-0 text-right text-lg-left"><strong>Atenção:</strong> Horários de publicação são computados no fuso horário de Brasília</p>
                  </div>
                </div> <!-- END SCHEDULE -->
                <template v-if="isChapter">
                  <!-- SAMPLE -->
                  <div class="default-form">
                    <div class="styled-checkbox">
                      <label for="sample">
                        <input
                          id="sample"
                          type="checkbox"
                          name="sample"
                          v-model="post.is_sample"
                        />
                        <span></span>
                        Capítulo amostra
                      </label>
                      <div
                          id="tooltip-sample"
                          class="text-color2 d-inline-block ml-1"
                          style="cursor:pointer;"
                          >
                            <i class="fa fa-info-circle"></i>
                        </div>
                      <b-tooltip custom-class="font-size-xSmall" target="tooltip-sample" triggers="hover">
                          <p class="mb-0">Capítulos amostra estarão disponíveis para leitura gratuita mesmo que o livro seja pago.</p>
                        </b-tooltip>
                    </div>
                  </div> <!-- END SAMPLE -->
                </template>
                <div v-if="!post.was_published_once" class="default-form">
                  <div class="styled-checkbox">
                    <label for="is_silent_publication">
                      <input
                        id="is_silent_publication"
                        type="checkbox"
                        name="is_silent_publication"
                        :value="true"
                        v-model="post.is_silent_publication"
                      />
                      <span></span>
                      Silenciar publicação
                      <i
                        class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                        v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                        title="Ao silenciar uma publicação, os seus seguidores não serão notificados quando esse conteúdo for publicado. Essa ação é irreversível."
                      ></i>
                    </label>
                  </div>
                </div>
              </div> <!-- END VISIBILITY -->
              <div v-if="!isChapter">
                <!-- LICENSE -->
                <div class="mb-5">
                    <h2 class="font-weight-bold font-size-regular text-center text-md-left mb-3">
                      Licença
                      <i
                        class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                        v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                        :title="licenseTooltipText"
                      ></i>
                    </h2>
                    <div class="form-group">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="font-size-small">Tipo de licença</span>
                        <div>
                          <DropdownSelect
                            v-model.trim="post.license"
                            :options="licenseOptions"
                            size="xSmall"
                          />
                        </div>
                      </div>
                      <p class="font-size-xSmall mt-2 text-color2 mb-0 text-right text-lg-left">Dica: {{ licenseTipText }}</p>
                    </div>
                </div><!-- END LICENSE -->
              </div>
              <!-- CATEGORIES -->
              <div
                class="mb-5"
                v-if="!isChapter && !isGroup"
              >
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h2 class="font-weight-bold font-size-regular text-center text-md-left">
                    Categoria
                    <i
                      class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                      v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                      :title="this.categoryTooltipText"
                      >
                    </i>
                  </h2>
                  <Button
                    class="btn-circle btn-circle-sm btn-outline-color2 d-inline-block hover-color-white"
                    v-b-modal.select-category
                  >
                    <i class="fa fa-plus"></i>
                  </Button>
                </div>
                <p
                  class="font-size-small"
                  v-if="!post.category_id && !selectedCategory"
                >
                  Sem categoria selecionada
                </p>
                <template v-else>
                  <Loader
                    color="color2"
                    size="medium"
                    v-if="selectedCategory === 'loading'"
                  />
                  <div
                    class="d-flex align-items-center category-item rounded-regular"
                    v-else-if="selectedCategory"
                  >
                    <div
                      class="image rounded-regular background-cover shadow-light"
                      :style="{ backgroundImage: `url('${selectedCategory.cover}')` }"
                    ></div>
                    <div class="content pl-2 d-flex align-items-center">
                      <span class="font-size-small">{{ selectedCategory.name }}</span>
                    </div>
                  </div>
                </template>
                <SelectCategoryModal
                  @category-selected="selectCategory"
                />
              </div> <!-- END CATEGORIES -->
              <!-- TAGS -->
              <div class="mb-5">
                <h2 class="font-weight-bold font-size-regular text-center text-md-left mb-3">
                  Tags
                  <i
                    class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                    v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                    :title="this.tagsTooltipText"
                    >
                  </i>
                </h2>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control bordered-bottom font-size-small pb-0 px-0 text-left w-100"
                    name="tag"
                    placeholder="Separe tags com enter ou vírgula"
                    v-model="tag"
                    @keyup.enter.188.prevent="storeTag"
                  />
                </div>
                <div
                  v-if="post.tags.length > 0"
                >
                  <ul
                    class="tag-list d-flex mt-3 flex-wrap"
                  >
                    <li
                      class="tag-item mb-3 mr-4 font-size-regular"
                      v-for="(tag, index) in post.tags"
                      :key="index"
                    >
                      <span class="tag">{{ tag }}</span>
                      <button
                        type="button"
                        class="remove-tag"
                        @click="removeTag(tag, index)"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div> <!-- END TAGS -->
              <!-- MODERATION -->
              <div class="mb-5">
                <h2 class="font-weight-bold font-size-regular text-center text-md-left mb-3">Moderação</h2>
                <div class="default-form">
                  <div class="styled-checkbox">
                    <label for="comments">
                      <input
                        id="comments"
                        type="checkbox"
                        name="comments"
                        v-model="post.is_comments_enabled"
                      />
                      <span></span>
                      Habilitar comentários
                    </label>
                  </div>
                  <div class="styled-checkbox">
                    <label for="sensible_content">
                      <input
                        id="sensible_content"
                        type="checkbox"
                        name="sensible_content"
                        v-model="post.is_sensible"
                      />
                      <span></span>
                      Marcar como conteúdo sensível
                      <i
                        class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                        v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                        title="Conteúdo sensível engloba assuntos que não são indicados para menores de 18 anos ou temas que podem gerar reações emocionais adversas no leitor. Para mais informações, consulte as Regras de Moderação."
                      ></i>
                    </label>
                  </div>
                </div>
              </div> <!-- END MODERATION -->
            </div> <!-- END CONFIGS -->
          </div>
        </div>
      </section>
  </div>
</template>

<script>

import { slugify, checkIfUserIsOwnerOfEntity, checkIfUserCanPublishOnGroup } from '@/utils'
import variables from '@/mixins/variables'
import { mapState, mapActions } from 'vuex'
import BooksService from '@/modules/books/services/books-service'
import CategoriesService from '@/modules/categories/services/categories-service'
import GroupsService from '@/modules/groups/services/groups-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import PostsService from '@/modules/posts/services/posts-service'

import Button from '@/components/common/Button/Button.vue'
import CoverSelectModal from '@/components/common/Cover/CoverSelectModal'
import CropperModal from '@/components/common/Cropper/CropperModal'
import DateTimeInput from '@/components/common/Input/DateTimeInput'
import DropdownSelect from '@/components/common/Select/DropdownSelect.vue'
import Loader from '@/components/common/Loader/Loader.vue'
import SelectCategoryModal from '@/components/categories/SelectCategoryModal'
import Editor from '@/components/common/Editor/Editor.vue'

import moment from 'moment'

export default {
  mixins: [variables],
  components: {
    Button,
    CoverSelectModal,
    CropperModal,
    DateTimeInput,
    DropdownSelect,
    Loader,
    SelectCategoryModal,
    Editor
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  data () {
    return {
      currentPost: null,
      book: null,
      group: null,
      cropSrc: '',
      post: {
        title: '',
        description: '',
        slug: '',
        visibility: 'public',
        license: 'cc-by-nc-nd',
        category_id: '',
        is_comments_enabled: true,
        is_sensible: false,
        status: '',
        tags: [],
        cover: null,
        type: null,
        content: '',
        publish_at: '',
        publish_method: 'publish',
        was_published_once: false,
        is_sample: false,
        default_cover: '',
        is_silent_publication: false
      },
      tag: '',
      selectedCategory: null,
      autoSaveInterval: null,
      autoSaving: false,
      isAutoSaveEnabled: false,
      discardingDraft: false,
      isDisabled: false,
      defaultCover: null
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('posts', {
      publishing: state => state.publishing,
      savingDraft: state => state.savingDraft,
      isSidebarOpen: state => state.isSidebarOpen,
      postData: state => state.postData
    }),
    cleanSlug () {
      return this.slug
    },
    coverImage () {
      let url = ''
      if (this.defaultCover) url = this.defaultCover.url
      else if (this.post.cover) url = URL.createObjectURL(this.post.cover)
      else {
        if (this.currentPost) url = this.currentPost.cover
        else url = this.noCoverUrl
      }
      return {
        backgroundImage: `url('${url}')`
      }
    },
    visibilityTipText () {
      if (this.post.visibility === 'public') return 'qualquer um poderá ver a publicação, a menos que seja rascunho'
      else if (this.post.visibility === 'private') return 'apenas você poderá ver a publicação'
      return ''
    },
    licenseTipText () {
      if (!this.post.license) return ''
      const option = this.licenseOptions.find(item => {
        return item.key === this.post.license
      })
      return option.description || ''
    },
    basePermalink () {
      if (!this.isChapter) return `${this.baseUrl}/${this.user ? this.user.username : 'username'}`
      return `${this.baseUrl}/${this.user ? this.user.username : 'username'}/b/${this.$route.params.bookSlug}`
    },
    isChapter () {
      const routeName = this.$route.name
      return !((routeName === 'posts.create' || routeName === 'posts.edit' || routeName === 'groups.posts.create' || routeName === 'groups.posts.edit'))
    },
    isGroup () {
      const routeName = this.$route.name
      return (routeName === 'groups.posts.create' || routeName === 'groups.posts.edit')
    },
    isScheduledPost () {
      if (this.post.status === 'published') return false
      if (this.post.status === 'scheduled') return true
      if (this.post.publish_at) {
        const publishDate = moment(this.post.publish_at)
        const now = moment()
        return publishDate.isAfter(now)
      }
      return false
    },
    pageTitle () {
      const routeName = this.$route.name
      switch (routeName) {
        case 'posts.create':
          return 'Criar postagem'
        case 'posts.edit':
          return 'Editar postagem'
        case 'chapters.create':
          return 'Criar capítulo'
        case 'chapters.edit' :
          return 'Editar capítulo'
        case 'groups.posts.create' :
          return 'Criar postagem de comunidade'
        case 'groups.posts.edit' :
          return 'Editar postagem de comunidade'
        default:
          return ''
      }
    },
    publishMethods () {
      const methods = [
        {
          key: 'publish',
          value: 'Publicar agora'
        }
      ]
      if (!this.post.was_published_once) {
        methods.push({
          key: 'schedule',
          value: 'Agendar'
        })
      }
      return methods
    }
  },
  watch: {
    publishing (newVal, oldVal) {
      if (newVal) {
        this.submit()
      }
    },
    savingDraft (newVal, oldVal) {
      if (newVal && !this.autoSaving & !this.isDisabled) {
        this.saveDraft()
      }
    },
    user (newUser, oldUser) {
      if (!this.currentPost) this.getPost()
      if (!this.book) this.getBook()
      if (!this.group) this.getGroup()
    },
    'post.publish_method' (newVal, oldVal) {
      this.setPostData({ postData: this.post })
    }
  },
  created () {
    // Check if is chapter or post to be created
    this.post.type = this.isChapter ? 'chapter' : 'post'
    if (this.user) this.getPost()
    if (this.user) this.getBook()
    if (this.user) this.getGroup()
    this.addQueryParameterTags()
    this.setAutoSaveInterval()
  },
  beforeDestroy () {
    this.clearAutoSaveInterval()
    this.setPostData({ postData: null })
  },
  methods: {
    ...mapActions('posts', [
      'setPostData'
    ]),
    // When select cover file, change the image
    changeCover (e) {
      const file = e.target.files[0]

      // Change default cover to blank
      this.post.default_cover = ''
      this.defaultCover = null

      // this.post.cover = file
      this.cropSrc = URL.createObjectURL(file)
    },
    setCover (blob) {
      this.post.cover = blob
    },
    // When change the title and doesnt have slug, create slug
    setSlug () {
      if (!this.post.slug) {
        this.post.slug = slugify(this.post.title)
      }
    },
    // When type tag on input, add to tag array
    storeTag (e, isString = false) {
      let value = isString ? e : e.target.value.replace(',', '')
      value = value.replaceAll('#', '').trim()
      if (!this.post.tags.includes(value)) {
        this.post.tags.push(value)
      }
      this.tag = ''
    },
    // Remove tag from tag array
    removeTag (tag, index) {
      this.post.tags.splice(index, 1)
    },
    // Get the selected category from API
    async selectCategory (id) {
      this.selectedCategory = 'loading'
      try {
        const category = await CategoriesService.getCategory(id)
        this.selectedCategory = Object.assign({}, category)
        this.post.category_id = category.id
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.selectedCategory = null
      }
    },
    updateContent (content) {
      // console.log(content)
      // this.post.content = content
    },
    async discard () {
      try {
        this.discardingDraft = true
        const id = this.currentPost ? this.currentPost.id : null
        await PostsService.destroyPost(id)
        this.autoSaving = false
        const notification = {
          notification: {
            type: 'success',
            content: 'Rascunho descartado com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$router.push('/')
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    // Submit the post or chapter to API
    async submit (isDraft = false, shouldNotify = false, seePreview = false) {
      // When is submiting, there's no autosave
      this.clearAutoSaveInterval()
      try {
        const id = this.currentPost ? this.currentPost.id : null
        let post = this.post
        // If is book, add id to form
        if (this.book) post.book_id = this.book.id
        // If is group, add id to form
        if (this.group) post.group_id = this.group.id
        post = await PostsService.post(id, this.post, isDraft)
        if (!isDraft) {
          if (this.isChapter) this.$router.push({ name: 'chapters.show', params: { username: post.user.username, bookSlug: post.book.slug, slug: post.slug } })
          else this.$router.push({ name: 'posts.show', params: { username: post.user.username, slug: post.slug } })
        } else {
          this.setPost(post, true)
          // this.currentPost = post
          this.autoSaving = false
          if (shouldNotify) {
            const notification = {
              notification: {
                type: 'success',
                content: 'Rascunho salvo com sucesso'
              }
            }
            NotificationService.createGlobalSuccessNotification(notification)
          }
          if (seePreview) {
            let routeData = null
            if (this.isChapter) {
              routeData = this.$router.resolve({ name: 'chapters.show', params: { username: post.user.username, bookSlug: post.book.slug, slug: post.slug } })
            } else {
              routeData = this.$router.resolve({ name: 'posts.show', params: { username: post.user.username, slug: post.slug } })
            }
            this.isDisabled = false
            window.open(routeData.href, '_blank')
          }
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      // Reenable autosave
      this.setAutoSaveInterval()
    },
    // Save the draft
    async saveDraft () {
      // Clear autosave interval so the timer "resets"
      this.clearAutoSaveInterval()
      await this.submit(true, true)
    },
    discardDraft () {
      // Clear autosave interval so the timer "resets"
      this.clearAutoSaveInterval()
      this.discard()
    },
    async seePreview () {
      this.isDisabled = true
      this.clearAutoSaveInterval()
      await this.submit(true, true, true)
    },
    // Autosave function
    autoSave () {
      if ((this.post.title || this.post.content || this.post.cover) && (this.post.status === 'draft' || this.post.status === '') && this.isAutoSaveEnabled) {
        this.autoSaving = true
        this.submit(true, false)
      }
    },
    // Get the post from API if its edit post or chapter route
    async getPost () {
      const routeName = this.$route.name
      if (routeName === 'posts.edit' || routeName === 'groups.posts.edit' || routeName === 'chapters.edit') {
        try {
          const post = await PostsService.getPost(this.$route.params.slug)
          checkIfUserIsOwnerOfEntity(post, this.user)
          this.setPost(post)
        } catch (error) {
          // If there is an error, redirect to home
          this.$router.push('/')
        }
      }
    },
    // Get Book of the chapter if its chapter
    async getBook () {
      if (this.isChapter) {
        try {
          const book = await BooksService.getBook(this.$route.params.bookSlug)
          checkIfUserIsOwnerOfEntity(book, this.user)
          this.book = book
          this.post.license = this.book.license
        } catch (error) {
          this.$router.push('/')
        }
      }
    },
    // Get group of the post if its group
    async getGroup () {
      if (this.$route.name === 'groups.posts.edit' || this.$route.name === 'groups.posts.create') {
        try {
          const group = await GroupsService.getGroup(this.$route.params.groupSlug)
          checkIfUserCanPublishOnGroup(group, this.user)
          this.group = group
        } catch (error) {
          this.$router.push('/')
        }
      }
    },
    // Set the post retrieved from API to local variable
    setPost (post, isDraft = false) {
      this.currentPost = post
      this.post.title = post.title
      this.post.slug = post.slug
      this.post.visibility = post.visibility
      this.post.license = post.license ? post.license : 'cc0'
      this.post.description = post.description ? post.description : ''
      this.post.is_comments_enabled = post.is_comments_enabled
      this.post.is_sensible = post.is_sensible
      if (!isDraft) this.post.content = this.parsePostContent(post.content)
      this.post.category_id = post.category ? post.category.id : ''
      this.post.status = post.status
      if (!isDraft && post.category) this.selectCategory(post.category.id)
      if (post.published_at) this.post.publish_at = post.published_at
      if (this.isScheduledPost) this.post.publish_method = 'schedule'
      if (post.chapter) this.post.is_sample = post.chapter.is_sample
      this.post.was_published_once = post.was_published_once
      if (!isDraft) {
        this.post.tags = []
        post.tags.forEach(tag => {
          this.post.tags.push(tag.name)
        })
      }
      this.setPostData({ postData: this.post })
    },
    // Parse the content retrived from API to check if is from Scriti (pure HTML) or Scriv (new format of json)
    parsePostContent (content) {
      try {
        // Replace old editor tags
        content = content.replaceAll('horizontal_rule', 'horizontalRule')
          .replaceAll('hard_break', 'hardBreak')
          .replaceAll('code_block', 'codeBlock')
          .replaceAll('bullet_list', 'bulletList')
          .replaceAll('list_item', 'listItem')
          .replaceAll('custom_image', 'image')

        return JSON.parse(content)
      } catch (e) {
        return content
        /* return {
          type: 'doc',
          content: [{
            type: 'paragraph',
            content: [
              {
                type: 'text',
                text: content
              }
            ]
          }]
        } */
      }
    },
    // Create intervaal for autosave
    setAutoSaveInterval () {
      this.isAutoSaveEnabled = true
      this.autoSaveInterval = setInterval(() => {
        this.autoSave()
      }, 30000)
    },
    // CLear interval of autosave
    clearAutoSaveInterval () {
      this.isAutoSaveEnabled = false
      clearInterval(this.autoSaveInterval)
    },
    addQueryParameterTags () {
      if (this.$route.query.tags && (this.$route.name === 'posts.create' || this.$route.name === 'groups.posts.create' || this.$route.name === 'chapters.create')) {
        const tags = this.$route.query.tags.split(',')
        tags.forEach(tag => {
          this.storeTag(tag, true)
        })
      }
    },
    // Add default cover to post object
    setDefaultCover (cover) {
      this.cropSrc = ''
      this.post.cover = null
      this.defaultCover = cover
      this.post.default_cover = cover.id
    }
  }
}
</script>

<style lang="scss" scoped>

/* SIDEBAR */
.sidebar {
  transition: right 0.2s ease-out;
  right: -100%;
  position: fixed;
  top: 80px;
  width: 100%;
  padding-top: 20px;
  background: #fff;
  z-index: 10;
  height: calc(100% - 80px);
  overflow-y: scroll;

  @include tablet {
    position: static;
    top: auto;
    right: auto;
    width: auto;
    padding-top: 0;
    background: transparent;
    z-index: inherit;
    height: auto;
    overflow: visible;
  }

  &.open {
    right: 0;
  }
}

.tag-item {
  position: relative;
  max-width: 100%;

  .tag {
    word-wrap: break-word;
    width: 100%;
  }

  .remove-tag {
    border: none;
    padding: 0;
    margin: 0;
    background: #fff;
    border-radius: 30px;
    position: absolute;
    top: -10px;
    right: -15px;
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    color: $color4;
    font-size: $font_size_xSmall;
  }
}

.category-item {
  .image {
    width: 60px;
    height: 40px;
  }
  .content {
    flex-grow: 1;
  }
}

.image-header {
  margin-top: 0;
  flex-direction: column;

  @include tablet {
    height: 200px;
    flex-direction: row;
  }
}
</style>
